import { ToolbarButton } from './ToolbarButton';
import { startAR } from './ar/ARUtils';

export class ToolbarButtonAR extends ToolbarButton {
    protected onClick = (): void => {
        startAR();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ToolbarButtonAR.tsx